export const translation = {
    UserManagement: {
        title: 'User Management',
        subTitle: 'Users',
        menuTitle: 'Users',
        users_unfiltered: 'Total users: {{total}}',
        users_filtered: "Showing {{visible}} of {{total}} $t(common:user, {'count': {{total}} })",
        seats_available: '<strong>Available seats: {{available}} of {{maximum}}.</strong> Contact <mailto /> to add more.',
        seats_exceeded: '<strong>All {{maximum}} seats have been assigned.</strong> Contact <mailto /> to add more.',
        confirmMessage: {
            reactivate: 'Are you sure you want to reactivate {{- user}}?',
            deactivate: 'Are you sure you want to deactivate {{- user}}?',
            delete: 'Are you sure you want to delete {{- user}}?',
            create: 'A new user with the following values will be created. The username can not be changed anymore. Is everything correct?'
        },
        addNew: 'Add New User',
        filter: 'Find user…',
        edit: 'Edit user information',
        attributes: {
            username: 'Username',
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email Address',
            createdAt: '$t(common:created)',
            status: 'Status',
            group: 'Role',
            enableOTP: 'Enable MFA (TOTP)'
        },
        status: {
            active: 'Active',
            inactive: 'Inactive'
        },
        groups: {
            admins: 'Administrator',
            analysts: 'User'
        },
        schemaMessages: {
            username: 'Please provide an username',
            firstName: 'Please provide a first name',
            lastName: 'Please provide a last name',
            email: 'Please provide an email address',
            validEmail: 'Please provide a valid email address'
        },
        transfer: 'Transfer Project Ownership',
        noProjects: 'User does not own any projects',
        newOwner: 'New Owner'
    },
    AttributesManagement: {
        title: 'Metadata Management',
        subTitle: 'Custom Asset Properties',
        menuTitle: 'Properties',
        headerText: "Showing {{filteredAttributesCount}} of {{allAttributesCount}} Asset $t(glossary:property, {'count': {{allAttributesCount}} })",
        userSuppliedValues: 'User-supplied values, up to {{charCount}} characters.',
        filter: 'Find property…',
        tableHeaders: {
            name: 'Property name',
            type: 'Field type',
            values: 'Values',
            target: 'Used in',
            createdAt: '$t(common:created)'
        },
        addNew: 'Add New Property'
    },
    AppTokens: {
        title: 'API Keys',
        subTitle: 'App Token Management',
        menuTitle: 'API Keys',
        api_key: 'API Key',
        headerText_one: 'Showing {{filtered}} of {{count}} token',
        headerText_other: 'Showing {{filtered}} of {{count}} tokens',
        table: {
            name: 'Name',
            description: 'Description',
            createdBy: 'Created by',
            createdAt: 'Created at',
            expiresAt: 'Expires at',
            revokedAt: 'Revoked at'
        },
        revoke: {
            title: 'Revoke Token',
            prompt: 'Are you sure you want to <strong>permanently revoke</strong> token "{{- name}}"?',
            confirm: 'Revoke Token',
            hint: 'Press & Hold to Revoke!',
            succeeded: 'Token "{{- name}}" successfully revoked!',
            failed: 'Unable to revoke token "{{- name}}".'
        },
        create: {
            button: 'New App Token',
            title_default: 'Create New App Token',
            title_succeeded: 'App Token Created!',
            name_placeholder: 'Enter a name for your application…',
            description_placeholder: 'Describe your application…',
            submit: 'Create',
            token: 'App Token',
            reminder: "Make sure to copy your API key now. You won't be able to see it again!",
            permissions_label: 'Permissions',
            permissions_manage_jobs: 'Manage Jobs',
            permissions_ingest_events: 'Ingest Events'
        },
        filter: 'Find app token…'
    },
    GlossaryManagement: {
        title: 'Metadata Management',
        subTitle: 'Glossary Terms',
        menuTitle: 'Glossary Terms',
        headerText: "Showing {{filteredTermsCount}} of {{allTermsCount}} glossary $t(glossary:term, {'count': {{allTermsCount}} })",
        tableHeaders: {
            name: 'Term Name',
            category: 'Category',
            description: 'Description'
        },
        manageCategories: 'Manage Categories',
        newTerm: 'Add New Term',
        filter: 'Find term…',
        errors: {
            categoryNameFormat: 'Category names can only consist of the following characters. A-Z, a-z, 0-9, dash, underscore (_), period (.), and space ( ). Names cannot begin with an underscore or space and cannot end with a space.',
            categoryNameLength: 'Category names must be at most 100 characters.',
            categoryNameExists: 'That category already exists.'
        },
        ConfigureGlossaryTermDialog: {
            title_new: 'New Glossary Term',
            title_edit: 'Configure Glossary Term',
            fields: {
                name: {
                    label: 'Name',
                    placeholder: 'Enter term name…',
                    warningUniq: "Term '{{- value}}' already exists. Term must be unique.",
                    warningChars: 'Term names can only consist of the following characters. A-Z, a-z, 0-9, dash, and underscore (_). Names cannot begin with an underscore or a space and cannot end with a space.',
                    warningRequired: 'Please provide a name.',
                    warningLength: 'Must be at most {{max}} characters.'
                },
                description: {
                    label: 'Description',
                    placeholder: 'Add some insights about the purpose of this term…',
                    warningRequired: 'Please provide a description.',
                    warningLength: 'Must be at most {{max}} characters.'
                },
                category: {
                    label: 'Category',
                    placeholder: 'Select category…',
                    warningRequired: 'Please choose a category.'
                }
            },
            errors: {
                whitespace: 'No leading or trailing whitespaces'
            }
        },
        manageCategoriesDialog: {
            title: 'Glossary Categories',
            hintText: 'Categories provide a simple way to organize related terms under a common label.'
        }
    },
    IntegrationsPage: {
        menuTitle: 'Integrations'
    },
    GithubIntegration: {
        title: 'GitHub',
        description: 'GitHub authentication setup for indexing DBT projects.',
        method: 'Authentication Method',
        token: 'Token',
        personalToken: 'Personal Access Token',
        personalTokenLink: 'Create fine-grained personal access tokens in GitHub',
        deleteGithubCredentials: 'Delete GitHub Credentials',
        DeleteDialog: {
            title: 'Delete GitHub Credentials',
            body: 'This will delete the credentials for this GitHub authentication.'
        },
        ServiceAccount: {
            title: 'Service Account'
        }
    },
    GoogleIntegration: {
        title: 'Google Sheets',
        AccountDetails: {
            clientEmail: 'Email',
            privateKeyId: 'Key ID',
            copySuccess: 'Email copied to clipboard'
        },
        DeleteDialog: {
            title: 'Delete Google Connection',
            body: 'This will delete the credentials for this Google service account'
        },
        ServiceAccount: {
            deleteGoogleConnection: 'Delete Google Connection',
            title: 'Service Account'
        },
        UploadConfigurationFile: {
            placeholder: 'Drop service account JSON file to upload',
            uploadButton: 'Browse…',
            processing: 'Processing JSON…',
            multiFileError: 'Multiple file upload is not supported.',
            fileTypeError: 'Only JSON files are supported.'
        }
    },
    SlackIntegration: {
        slack: 'Slack',
        addToSlack: 'Add to Slack',
        addToDatameerToWorkspace: 'Add Datameer to your Slack Workspace',
        slackIntegrationNotAvailable: 'Slack Integration is not available. Contact Datameer Support for further assistance.',
        configurationDetails: 'Configuration Details',
        workspace: 'Workspace',
        authorizationDate: 'Authorized on',
        authorizedBy: 'Authorized by',
        botName: 'Bot name',
        removeFromSlack: 'Remove from Slack',
        deleteTooltip: 'Remove Datameer App from your Slack Workspace',
        DeleteDialog: {
            title: 'Delete Slack Configuration',
            body: 'This will remove Datameer App from your Slack Workspace'
        }
    },
    OpenAIIntegration: {
        openai: 'OpenAI',
        model: 'Model',
        apiKey: 'API Key',
        organizationKey: 'Organization Key'
    },
    SnowflakeSettings: {
        menuTitle: 'Snowflake Settings',
        title: 'Snowflake Settings',
        subtitle: 'Service Account',
        description: 'All end users access Snowflake from a common service account defined for the entire system.',

        error: {},
        privateKey: {
            upload: 'Drag and drop your key',
            browse: 'Browse File…',
            inputPlaceholder: 'Or paste your private key directly here',
            fileName: 'File name'
        },
        privateKeyPassword: {
            label: 'Key Passphrase (Optional)',
            placeholder: 'Enter key password'
        },
        faq: {
            title: 'FAQ',
            accountName: {
                title: 'Where to find your Snowflake account name?',
                body: '<p>https://<sample>[account_name]</sample>.snowflakecomputing.com</p><p>Your account name may include information to identify the cloud platform or where your account is hosted:</p><samples><sample>account</sample><sample>account.us-east-2.aws</sample><sample>account.europe-west4.gcp</sample><sample>account.southeast-asia.azure</sample></samples><p>For more information on account names and URLs visit the <docs>Snowflake Documentation</docs>.</p>'
            },
            sso: {
                title: 'Using SSO or can’t login?',
                body: 'Learn how to <docs>Configure Your Service Account</docs>.'
            },
            whitelistedIps: {
                title: 'How to only allow access to white listed IP addresses?',
                body: 'If your Snowflake is configured to only allow access IP addresses on a white list, please contact <mailto>support@datameer.com</mailto> to guide you through the required configuration changes.'
            }
        }
    },
    AdvancedConfiguration: {
        menuTitle: 'Advanced Configuration',
        title: 'Advanced Configuration',
        subTitle: 'Datameer Application',
        description: 'Datameer specific set of properties that impact how the application runs. For a list of possible properties refer to our <0>Documentation</0>.',
        textHint: 'e.g. snowflake.data-preview.sample-size=1000'
    }
};
